import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';


export const fetchCategoryViews = async () =>
  await fetch(
    Config.endpoints.FETCH_CATEGORY_VIEWS_LIST
  )
    .then(
      handleErrors({
        errorMessage: 'Fetching Category Views failed',
      })
    )
    .then(parseAsJson);

export const fetchTags = async (periodName, categoryName) =>
  await fetch(
    Config.endpoints.FETCH_TAGS_FOR_CATEGORY_LIST
      .replace(/:periodName/, periodName )
      .replace(/:categoryName/, categoryName)
  )
    .then(
      handleErrors({
        errorMessage: 'Fetching Tags failed',
        parseResponseErrorMessage: true,
      })
    )
    .then(parseAsJson);

export const addCategory = async ({ periodName, categoryData }) =>
  await fetch(
    Config.endpoints.ADD_CATEGORY.replace(/:periodName/, periodName),
    {
      method: 'POST',
      body: JSON.stringify({
        categoryName: categoryData.categoryName,
        description: categoryData.description,
        catView: categoryData.catView,
        defaultTag: categoryData.defaultTag,
        subCategoryName: categoryData.subCategoryName,
      }),
    }
  ).then(handleErrors({ errorMessage: 'Adding Category failed' }));

export const editCategory = async ({ periodName, categoryData }) =>
  await fetch(
    Config.endpoints.EDIT_CATEGORY
      .replace(/:periodName/, periodName)
      .replace(/:categoryName/, categoryData.categoryName),
    {
      method: 'PUT',
      body: JSON.stringify({
        description: categoryData.description,
        catView: categoryData.catView,
        defaultTag: categoryData.defaultTag,
        subCategoryName: categoryData.subCategoryName,
      }),
    }
  ).then(handleErrors({ errorMessage: 'Editing Category failed' }));

export const deleteCategory = async ({ periodName, categoryName }) =>
  await fetch(
    Config.endpoints.DELETE_CATEGORY
      .replace(/:periodName/, periodName)
      .replace(/:categoryName/, categoryName),
    {
      method: 'DELETE',
    }
  ).then(handleErrors({ errorMessage: 'Deleting Category failed' }));

export const addTag = async ({ tagData, periodName, category }) => await fetch(
  Config.endpoints.ADD_TAG
    .replace(/:periodName/, periodName)
    .replace(/:categoryName/, encodeURIComponent(category)), {
    method: 'POST',
    body: JSON.stringify(tagData),
  }
).then(handleErrors({ errorMessage: 'Adding Tag failed' }));

export const updateTag = async ({ tagData, periodName, category }) => await fetch(
  Config.endpoints.UPDATE_TAG
    .replace(/:periodName/, periodName)
    .replace(/:categoryName/, encodeURIComponent(category))
    .replace(/:tagName/, encodeURIComponent(tagData.tagName)),
  {
    method: 'PUT',
    body: JSON.stringify(tagData),
  }
)
  .then(handleErrors({ errorMessage: 'Updating Tag failed' }));

export const deleteTag = async ({ tagName, periodName, categoryName }) => await fetch(
  Config.endpoints.DELETE_TAG
    .replace(/:periodName/, periodName)
    .replace(/:categoryName/, encodeURIComponent(categoryName))
    .replace(/:tagName/, encodeURIComponent(tagName)),
  {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Deleting Tag failed' }));

export const validateTags = ({ periodName, categoryName, tags }) => fetch(
  Config.endpoints.VALIDATE_TAGS
    .replace(/:periodName/, periodName)
    .replace(/:categoryName/, categoryName),
  {
    method: 'POST',
    body: JSON.stringify(tags),
  }
)
  .then(handleErrors({ errorMessage: 'Validating import file failed' }))
  .then(parseAsJson);

export const importTags = ({ periodName, categoryName, tags }) => fetch(
  Config.endpoints.IMPORT_TAGS
    .replace(/:periodName/, periodName)
    .replace(/:categoryName/, categoryName),
  {
    method: 'POST',
    body: JSON.stringify(tags),
  }
)
  .then(handleErrors({ errorMessage: 'Importing tags failed' }));
